<template>
  <div v-if="store.store_id != -1">

    <div class="header" :style="{backgroundImage:'url('+store.mb_title_img+')'}">
      <div class="content-wrapper">
        <div class="avatar" @click="goStoreabout">
          <img :src="store.store_avatar">
        </div>
        <div class="content">
          <div class="store_name">
            {{ store.store_name }}
            <span class="ml-5"
                  v-if="(store.is_platform_store && config.business_licence) || store.business_licence_number_electronic"
                  @click="imageVisible=true">
                <i class="iconfont">&#xe621;</i>
              </span>
          </div>
          <div class="store_address" v-if="store.store_address"
               @click="$router.push({name:'HomeStoremap',query:{id:store.store_id}})">
            <span class="iconfont">&#xe6d3;</span>
            <span v-if="store.store_address">{{ store.store_address }}</span>
          </div>
        </div>
        <div class="follow_panel">
          <div class="follow_button" @click="toggleFavorite">
            <i class="iconfont" :class="{'active':store.is_favorate}" v-html="favoriteIco"></i>
            {{ favoriteName }}
          </div>
          <div class="follow_number">
            {{store.store_collect}} جمع كمية
          </div>
        </div>
        <i class="header-more iconfont" @click="popupMore">&#xe680;<div v-if="showDot" class="dot"></div></i>
      </div>
      <div class="background">
        <img v-if="store.store_logo" v-lazy="store.store_logo" width="100%" height="100%">
        <img v-else v-lazy="store.store_logo" width="100%" height="100%">
      </div>
    </div>
    <header-more v-show="popupVisible" :showDot="showDot"></header-more>

    <store-special-index v-show="special && special['store/index'+store.store_id]" :page-path="'store/index'"
                         :item-id="''"></store-special-index>

    <div class="container" v-show="!special || !special['store/index'+store.store_id]">
<!--      <div class="header" :style="{backgroundImage:'url('+store.mb_title_img+')'}">
        <div class="content-wrapper">
          <div class="avatar" @click="goStoreabout">
            <img :src="store.store_avatar">
          </div>
          <div class="content">
            <div class="store_name">
              {{ store.store_name }}
              <span class="ml-5"
                    v-if="(store.is_platform_store && config.business_licence) || store.business_licence_number_electronic"
                    @click="imageVisible=true">
                <i class="iconfont">&#xe621;</i>
              </span>
            </div>
            <div class="store_address" v-if="store.store_address"
                 @click="$router.push({name:'HomeStoremap',query:{id:store.store_id}})">
              <span class="iconfont">&#xe6d3;</span>
              <span v-if="store.store_address">{{ store.store_address }}</span>
            </div>
          </div>
          <div class="follow_panel">
            <div class="follow_button" @click="toggleFavorite">
              <i class="iconfont" :class="{'active':store.is_favorate}" v-html="favoriteIco"></i>
              {{ favoriteName }}
            </div>
            <div class="follow_number">
              {{ store.store_collect }} جمع الناس
            </div>
          </div>
          <i class="header-more iconfont" @click="popupMore">&#xe680;<div v-if="showDot" class="dot"></div>
          </i>
        </div>
        <div class="background">
          <img v-if="store.store_logo" v-lazy="store.store_logo" width="100%" height="100%">
          <img v-else v-lazy="store.store_logo" width="100%" height="100%">
        </div>
      </div>
      <header-more v-show="popupVisible" :showDot="showDot"></header-more>-->
      <!--直播start-->
      <div class="box-wrapper h live-wrapper" v-if="store.live_apply_info"
           @click="goLive(store.live_apply_info.live_apply_id)">
        <div class="box-wrapper v live-back-wrapper">
          <img :src="store.live_apply_info.live_apply_cover_image_url" class="live-back-image"/>
          <div class="box-wrapper v live-back-cover"></div>
        </div>
        <div class="box-wrapper v left">
          <div class="box-wrapper v live-image">
            <video v-if="store.live_apply_info.live_apply_cover_video"
                   :src="store.live_apply_info.live_apply_cover_video_url" muted="muted" autoplay="autoplay"
                   loop="loop"/>
            <img v-else :src="store.live_apply_info.live_apply_cover_image_url">
          </div>
          <span class="live-store">تسوق مباشرة</span>
        </div>
        <div class="box-wrapper v right">
          <div class="box-wrapper v live-info">
            <div class="box-wrapper v live-btn">
              <span class="live-btn-text">شاهد الآن</span>
            </div>
            <span class="live-title">{{ store.live_apply_info.live_apply_name }}</span>
            <div class="box-wrapper v live-desc">
              <span class="live-count">{{ store.live_apply_info.live_apply_view_count }} الآراء</span>
              <img src="../../../assets/image/live/live-state.png" class="live-icon"/>
            </div>
          </div>
          <div class="box-wrapper h goods-list" v-if="store.live_apply_info.goods_list">
            <div class="box-wrapper v goods-wrapper" v-for="item in store.live_apply_info.goods_list"
                 :key="item.goods_id">
              <img :src="item.goods_image_url" class="goods-image"/>
              <div class="box-wrapper h goods-price">
                <span class="currency">{{ this.currency }}</span>
                <span class="price">{{ item.goods_price }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--直播end-->
      <mt-swipe class="mt-5" v-if="store.mb_sliders && store.mb_sliders.length" v-bind:style="getBannerStyle"
                :showIndicators="isShowIndicators">
        <mt-swipe-item v-for="(item, index) in store.mb_sliders" :key="index">
          <img :style="getBannerStyle" v-lazy="item.imgUrl" @click="goAd(item)">
        </mt-swipe-item>
      </mt-swipe>
      <store-product-list
        :items="rec_goods_list"
        v-if="rec_goods_list && rec_goods_list.length > 0"
      ></store-product-list>
      <common-store-footer :store_id="store.store_id"></common-store-footer>
      <mt-popup v-model="imageVisible" popup-transition="popup-fade" class="middle-popup">
        <img v-if="store.business_licence_number_electronic" :src="store.business_licence_number_electronic">
        <img v-if="store.is_platform_store && config.business_licence" :src="config.business_licence">
      </mt-popup>
    </div>
  </div>

  <div v-else>

    <!--店铺13-->
    <store-special-index v-show="special && special['store/index'+store.store_id]" :page-path="'store/index'"
                         :item-id="''"></store-special-index>
    <div class="container" v-show="!special || !special['store/index'+store.store_id]">
      <div class="header" :style="{backgroundImage:'url('+store.mb_title_img+')'}">
        <div class="content-wrapper">
          <div class="avatar" @click="goStoreabout">
            <img :src="store.store_avatar">
          </div>
          <div class="content">
            <div class="store_name">
              {{ store.store_name }}
              <span class="ml-5"
                    v-if="(store.is_platform_store && config.business_licence) || store.business_licence_number_electronic"
                    @click="imageVisible=true"><i class="iconfont">&#xe621;</i>
              </span>
            </div>
            <div class="store_address" v-if="store.store_address"
                 @click="$router.push({name:'HomeStoremap',query:{id:store.store_id}})">
              <span class="iconfont">&#xe6d3;</span>
              <span v-if="store.store_address">{{ store.store_address }}</span>
            </div>
          </div>
          <div class="follow_panel">
            <div class="follow_button" @click="toggleFavorite">
              <i class="iconfont" :class="{'active':store.is_favorate}" v-html="favoriteIco"></i>
              {{ favoriteName }}
            </div>
            <div class="follow_number">
              {{ store.store_collect }} جمع الناس
            </div>
          </div>
          <i class="header-more iconfont" @click="popupMore">&#xe680;<div v-if="showDot" class="dot"></div>
          </i>
        </div>
        <div class="background">
          <img v-if="store.store_logo" v-lazy="store.store_logo" width="100%" height="100%">
          <img v-else v-lazy="store.store_logo" width="100%" height="100%">
        </div>
      </div>
      <header-more v-show="popupVisible" :showDot="showDot"></header-more>

      <mt-swipe v-bind:style="getBannerStyle2" :showIndicators="isShowIndicators2">
        <mt-swipe-item v-for="(item, index) in items" :key="index">
          <img :style="getBannerStyle2" v-lazy="item.adv_code" v-if='item.adv_code'>
          <img :style="getBannerStyle2" src="../../../assets/image/home/default_image_banner.png" v-else>
        </mt-swipe-item>
      </mt-swipe>

      <div class="floor-ad" v-if="floorAds" style="margin-top: 0.6rem;">
        <img v-lazy="floorAds[0]"/>
      </div>

      <store-seckill-list
        :items="seckill_goods_list"
        v-if="seckill_goods_list && seckill_goods_list.length > 0"
      ></store-seckill-list>

      <div class="new_arrivals">
        <div class="new_arrivals_bt">
          <div class="h3">تسوّق عروض اليوم</div>
        </div>
        <div class="new_arrivals_con">
          <div class="new_arrivals_scroller">
            <div class="new_arrivals_section">

              <div class="new_arrivals_item" v-on:click='goDetail(218)'>
                <a class="a-link-normal" href="javascript:void(0);">
                  <div class="a-image-container">
                    <img src="https://www.oubv.net/uploads/home/store/goods/13/20230711/13_2023071110385670733_240.png">
                  </div>
                  <div class="a-spacing-top-base">
                    <div class="a-row">
                      <!--                      <span>
                                              <span class="a-size-mini">خصم يصل إلى %</span>
                                              <span class="a-size-mini">16</span>
                                            </span>-->
                      <span>
                        <span>{{ currency }}{{ 13.8, exchangerate | currency2 }}</span>
                      </span>
                    </div>
                  </div>
                  <div class="a-desc">
                    الخزف الأزرق الداكن أدوات المائدة
                  </div>
                </a>
              </div>

              <div class="new_arrivals_item" v-on:click='goDetail(216)'>
                <a class="a-link-normal" href="javascript:void(0);">
                  <div class="a-image-container">
                    <img src="https://www.oubv.net/uploads/home/store/goods/13/20230711/13_2023071110344112843_240.png">
                  </div>
                  <div class="a-spacing-top-base">
                    <div class="a-row">
                      <span>
                        <span>{{ currency }}{{ 26, exchangerate | currency2 }}</span>
                      </span>
                    </div>
                  </div>
                  <div class="a-desc">
                    أدوات المطبخ بمقبض مجوف
                  </div>
                </a>
              </div>
              <div class="new_arrivals_item" v-on:click='goDetail(211)'>
                <a class="a-link-normal" href="javascript:void(0);">
                  <div class="a-image-container">
                    <img src="https://www.oubv.net/uploads/home/store/goods/13/20230711/13_2023071110063345419_240.png">
                  </div>
                  <div class="a-spacing-top-base">
                    <div class="a-row">
                      <span>
                        <span>{{ currency }}{{ 46.5, exchangerate | currency2 }}</span>
                      </span>
                    </div>
                  </div>
                  <div class="a-desc">
                    APP التحكم حامل سكين التطهير بالأشعة فوق البنفسجية
                  </div>
                </a>
              </div>
              <div class="new_arrivals_item" v-on:click='goDetail(221)'>
                <a class="a-link-normal" href="javascript:void(0);">
                  <div class="a-image-container">
                    <img src="https://www.oubv.net/uploads/home/store/goods/13/20230711/13_2023071110431921569_240.png">
                  </div>
                  <div class="a-spacing-top-base">
                    <div class="a-row">
                      <span>
                        <span>{{ currency }}{{ 5.8, exchangerate | currency2 }}</span>
                      </span>
                    </div>
                  </div>
                  <div class="a-desc">
                    أدوات المائدة السيراميك الأسود
                  </div>
                </a>
              </div>
              <div class="new_arrivals_item" v-on:click='goDetail(223)'>
                <a class="a-link-normal" href="javascript:void(0);">
                  <div class="a-image-container">
                    <img src="https://www.oubv.net/uploads/home/store/goods/13/20230720/13_2023072009563145010_240.png">
                  </div>
                  <div class="a-spacing-top-base">
                    <div class="a-row">
                      <span>
                        <span>{{ currency }}{{ 2.4, exchangerate | currency2 }}</span>
                      </span>
                    </div>
                  </div>
                  <div class="a-desc">
                    4 قطع أدوات المائدة
                  </div>
                </a>
              </div>
              <div class="new_arrivals_item" v-on:click='goDetail(209)'>
                <a class="a-link-normal" href="javascript:void(0);">
                  <div class="a-image-container">
                    <img src="https://www.oubv.net/uploads/home/store/goods/13/20230711/13_2023071109233032784_240.png">
                  </div>
                  <div class="a-spacing-top-base">
                    <div class="a-row">
                      <span>
                        <span>{{ currency }}{{ 19.5, exchangerate | currency2 }}</span>
                      </span>
                    </div>
                  </div>
                  <div class="a-desc">
                    دلو أدوات المائدة 24 قطعة
                  </div>
                </a>
              </div>
              <div class="new_arrivals_item" v-on:click='goDetail(210)'>
                <a class="a-link-normal" href="javascript:void(0);">
                  <div class="a-image-container">
                    <img src="https://www.oubv.net/uploads/home/store/goods/13/20230711/13_2023071109262883154_240.png">
                  </div>
                  <div class="a-spacing-top-base">
                    <div class="a-row">
                      <span>
                        <span>{{ currency }}{{ 48.5, exchangerate | currency2 }}</span>
                      </span>
                    </div>
                  </div>
                  <div class="a-desc">
                    25 قطعة حامل سكين التطهير بالأشعة فوق البنفسجية
                  </div>
                </a>
              </div>
              <div class="new_arrivals_item" v-on:click='goDetail(214)'>
                <a class="a-link-normal" href="javascript:void(0);">
                  <div class="a-image-container">
                    <img src="https://www.oubv.net/uploads/home/store/goods/13/20230711/13_2023071110221273184_240.png">
                  </div>
                  <div class="a-spacing-top-base">
                    <div class="a-row">
                      <span>
                        <span>{{ currency }}{{ 9.6, exchangerate | currency2 }}</span>
                      </span>
                    </div>
                  </div>
                  <div class="a-desc">
                    الاكريليك الخشب سكين حامل
                  </div>
                </a>
              </div>
              <div class="new_arrivals_item" v-on:click='goDetail(222)'>
                <a class="a-link-normal" href="javascript:void(0);">
                  <div class="a-image-container">
                    <img src="https://www.oubv.net/uploads/home/store/goods/13/20230711/13_2023071110472290519_240.png">
                  </div>
                  <div class="a-spacing-top-base">
                    <div class="a-row">
                      <span>
                        <span>{{ currency }}{{ 8.8, exchangerate | currency2 }}</span>
                      </span>
                    </div>
                  </div>
                  <div class="a-desc">
                    30 قطعة من أواني الطعام
                  </div>
                </a>
              </div>
              <div class="new_arrivals_item" v-on:click='goDetail(207)'>
                <a class="a-link-normal" href="javascript:void(0);">
                  <div class="a-image-container">
                    <img src="https://www.oubv.net/uploads/home/store/goods/13/20230710/13_2023071013415414706_240.png">
                  </div>
                  <div class="a-spacing-top-base">
                    <div class="a-row">
                      <span>
                        <span>{{ currency }}{{ 48.5, exchangerate | currency2 }}</span>
                      </span>
                    </div>
                  </div>
                  <div class="a-desc">
                    قدر ضغط صغير
                  </div>
                </a>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div class="floor-ad" v-if="floorAds">
        <img v-lazy="floorAds[1]"/>
      </div>

      <!--新品-->
      <div class="recommended">
        <div class="recommended_bt">
          <div class="h3">منتج جديد</div>
        </div>
        <div class="recommended_con">

          <div class="recommended_item" v-on:click='goDetail(213)'>
            <div class="recommended_item_box">
              <a class="Product-media" href="javascript:void(0);">
                <img src="https://www.oubv.net/uploads/home/store/goods/13/20230713/13_2023071317161849183_240.png"
                     class="Product-image">
              </a>
              <div class="Product-details">
                <a class="Product-link" href="javascript:void(0);">
                  <div class="Product-name">قاعدة الحديد لوحة التقطيع قاعدة السكين</div>
                  <div class="Product-priceDetails"><span
                    class="Product-minPrice">{{ currency }}{{ 15.8, exchangerate | currency2 }}</span></div>
                </a>
              </div>
            </div>
          </div>
          <div class="recommended_item" v-on:click='goDetail(214)'>
            <div class="recommended_item_box">
              <a class="Product-media" href="javascript:void(0);">
                <img src="https://www.oubv.net/uploads/home/store/goods/13/20230711/13_2023071110221273184_240.png"
                     class="Product-image">
              </a>
              <div class="Product-details">
                <a class="Product-link" href="javascript:void(0);">
                  <div class="Product-name">الاكريليك الخشب سكين حامل</div>
                  <div class="Product-priceDetails"><span
                    class="Product-minPrice">{{ currency }}{{ 9.6, exchangerate | currency2 }}</span></div>
                </a>
              </div>
            </div>
          </div>
          <div class="recommended_item" v-on:click='goDetail(211)'>
            <div class="recommended_item_box">
              <a class="Product-media" href="javascript:void(0);">
                <img src="https://www.oubv.net/uploads/home/store/goods/13/20230711/13_2023071110063345419_240.png"
                     class="Product-image">
              </a>
              <div class="Product-details">
                <a class="Product-link" href="javascript:void(0);">
                  <div class="Product-name">APP التحكم حامل سكين التطهير بالأشعة فوق البنفسجية</div>
                  <div class="Product-priceDetails"><span
                    class="Product-minPrice">{{ currency }}{{ 46.5, exchangerate | currency2 }}</span></div>
                </a>
              </div>
            </div>
          </div>
          <div class="recommended_item" v-on:click='goDetail(212)'>
            <div class="recommended_item_box">
              <a class="Product-media" href="javascript:void(0);">
                <img src="https://www.oubv.net/uploads/home/store/goods/13/20230711/13_2023071110134655849_240.png"
                     class="Product-image">
              </a>
              <div class="Product-details">
                <a class="Product-link" href="javascript:void(0);">
                  <div class="Product-name">حامل سكين من سبائك الألومنيوم للشحن اللاسلكي</div>
                  <div class="Product-priceDetails"><span
                    class="Product-minPrice">{{ currency }}{{ 20, exchangerate | currency2 }}</span></div>
                </a>
              </div>
            </div>
          </div>
          <div class="recommended_item" v-on:click='goDetail(210)'>
            <div class="recommended_item_box">
              <a class="Product-media" href="javascript:void(0);">
                <img src="https://www.oubv.net/uploads/home/store/goods/13/20230711/13_2023071109262883154_240.png"
                     class="Product-image">
              </a>
              <div class="Product-details">
                <a class="Product-link" href="javascript:void(0);">
                  <div class="Product-name">25 قطعة حامل سكين التطهير بالأشعة فوق البنفسجية</div>
                  <div class="Product-priceDetails"><span
                    class="Product-minPrice">{{ currency }}{{ 48.5, exchangerate | currency2 }}</span></div>
                </a>
              </div>
            </div>
          </div>
          <div class="recommended_item" v-on:click='goDetail(215)'>
            <div class="recommended_item_box">
              <a class="Product-media" href="javascript:void(0);">
                <img src="https://www.oubv.net/uploads/home/store/goods/13/20230711/13_2023071110332768321_240.png"
                     class="Product-image">
              </a>
              <div class="Product-details">
                <a class="Product-link" href="javascript:void(0);">
                  <div class="Product-name">جوفاء الصلب مقبض</div>
                  <div class="Product-priceDetails"><span
                    class="Product-minPrice">{{ currency }}{{ 10, exchangerate | currency2 }}</span></div>
                </a>
              </div>
            </div>
          </div>
          <div class="recommended_item" v-on:click='goDetail(207)'>
            <div class="recommended_item_box">
              <a class="Product-media" href="javascript:void(0);">
                <img src="https://www.oubv.net/uploads/home/store/goods/13/20230710/13_2023071013415184411_240.png"
                     class="Product-image">
              </a>
              <div class="Product-details">
                <a class="Product-link" href="javascript:void(0);">
                  <div class="Product-name">قدر ضغط صغير</div>
                  <div class="Product-priceDetails"><span class="Product-minPrice">{{ currency }}{{
                      46.5, exchangerate | currency2
                    }}-{{ currency }}{{ 48.5, exchangerate | currency2 }}</span></div>
                </a>
              </div>
            </div>
          </div>
          <div class="recommended_item" v-on:click='goDetail(208)'>
            <div class="recommended_item_box">
              <a class="Product-media" href="javascript:void(0);">
                <img src="https://www.oubv.net/uploads/home/store/goods/13/20230711/13_2023071109175464864_240.png"
                     class="Product-image">
              </a>
              <div class="Product-details">
                <a class="Product-link" href="javascript:void(0);">
                  <div class="Product-name">دلو تجفيف وتعقيم أدوات المائدة</div>
                  <div class="Product-priceDetails"><span class="Product-minPrice">{{ currency }}{{
                      46.5, exchangerate | currency2
                    }}-{{ currency }}{{ 48.5, exchangerate | currency2 }}</span></div>
                </a>
              </div>
            </div>
          </div>
          <div class="recommended_item" v-on:click='goDetail(209)'>
            <div class="recommended_item_box">
              <a class="Product-media" href="javascript:void(0);">
                <img src="https://www.oubv.net/uploads/home/store/goods/13/20230711/13_2023071109233032784_240.png"
                     class="Product-image">
              </a>
              <div class="Product-details">
                <a class="Product-link" href="javascript:void(0);">
                  <div class="Product-name">دلو أدوات المائدة 24 قطعة</div>
                  <div class="Product-priceDetails"><span
                    class="Product-minPrice">{{ currency }}{{ 19.5, exchangerate | currency2 }}</span></div>
                </a>
              </div>
            </div>
          </div>
          <div class="recommended_item" v-on:click='goDetail(224)'>
            <div class="recommended_item_box">
              <a class="Product-media" href="javascript:void(0);">
                <img src="https://www.oubv.net/uploads/home/store/goods/13/20230711/13_2023071110584516504_240.png"
                     class="Product-image">
              </a>
              <div class="Product-details">
                <a class="Product-link" href="javascript:void(0);">
                  <div class="Product-name">قدر ضغط صغير بمقبض دفع مباشر</div>
                  <div class="Product-priceDetails"><span class="Product-minPrice">{{ currency }}{{
                      46.5, exchangerate | currency2
                    }}-{{ currency }}{{ 48.5, exchangerate | currency2 }}</span></div>
                </a>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!--热销-->
      <div class="recommended">
        <div class="recommended_bt">
          <div class="h3">منتوجات جديدة</div>
        </div>
        <div class="recommended_con">

          <div class="recommended_item" v-on:click='goDetail(223)'>
            <div class="recommended_item_box">
              <a class="Product-media" href="javascript:void(0);">
                <img src="https://www.oubv.net/uploads/home/store/goods/13/20230720/13_2023072009563145010_240.png"
                     class="Product-image">
              </a>
              <div class="Product-details">
                <a class="Product-link" href="javascript:void(0);">
                  <div class="Product-name">4 قطع أدوات المائدة</div>
                  <div class="Product-priceDetails"><span
                    class="Product-minPrice">{{ currency }}{{ 2.4, exchangerate | currency2 }}</span></div>
                </a>
              </div>
            </div>
          </div>
          <div class="recommended_item" v-on:click='goDetail(221)'>
            <div class="recommended_item_box">
              <a class="Product-media" href="javascript:void(0);">
                <img src="https://www.oubv.net/uploads/home/store/goods/13/20230711/13_2023071110431921569_240.png"
                     class="Product-image">
              </a>
              <div class="Product-details">
                <a class="Product-link" href="javascript:void(0);">
                  <div class="Product-name">أدوات المائدة السيراميك الأسود</div>
                  <div class="Product-priceDetails"><span
                    class="Product-minPrice">{{ currency }}{{ 5.8, exchangerate | currency2 }}</span></div>
                </a>
              </div>
            </div>
          </div>
          <div class="recommended_item" v-on:click='goDetail(218)'>
            <div class="recommended_item_box">
              <a class="Product-media" href="javascript:void(0);">
                <img src="https://www.oubv.net/uploads/home/store/goods/13/20230711/13_2023071110385670733_240.png"
                     class="Product-image">
              </a>
              <div class="Product-details">
                <a class="Product-link" href="javascript:void(0);">
                  <div class="Product-name">الخزف الأزرق الداكن أدوات المائدة</div>
                  <div class="Product-priceDetails"><span
                    class="Product-minPrice">{{ currency }}{{ 13.8, exchangerate | currency2 }}</span></div>
                </a>
              </div>
            </div>
          </div>
          <div class="recommended_item" v-on:click='goDetail(216)'>
            <div class="recommended_item_box">
              <a class="Product-media" href="javascript:void(0);">
                <img src="https://www.oubv.net/uploads/home/store/goods/13/20230711/13_2023071110344112843_240.png"
                     class="Product-image">
              </a>
              <div class="Product-details">
                <a class="Product-link" href="javascript:void(0);">
                  <div class="Product-name">أدوات المطبخ بمقبض مجوف</div>
                  <div class="Product-priceDetails"><span
                    class="Product-minPrice">{{ currency }}{{ 26, exchangerate | currency2 }}</span></div>
                </a>
              </div>
            </div>
          </div>
          <div class="recommended_item" v-on:click='goDetail(222)'>
            <div class="recommended_item_box">
              <a class="Product-media" href="javascript:void(0);">
                <img src="https://www.oubv.net/uploads/home/store/goods/13/20230711/13_2023071110471694843_240.png"
                     class="Product-image">
              </a>
              <div class="Product-details">
                <a class="Product-link" href="javascript:void(0);">
                  <div class="Product-name">30 قطعة من أواني الطعام</div>
                  <div class="Product-priceDetails"><span
                    class="Product-minPrice">{{ currency }}{{ 8.8, exchangerate | currency2 }}</span></div>
                </a>
              </div>
            </div>
          </div>
          <div class="recommended_item" v-on:click='goDetail(224)'>
            <div class="recommended_item_box">
              <a class="Product-media" href="javascript:void(0);">
                <img src="https://www.oubv.net/uploads/home/store/goods/13/20230711/13_2023071110584516504_240.png"
                     class="Product-image">
              </a>
              <div class="Product-details">
                <a class="Product-link" href="javascript:void(0);">
                  <div class="Product-name">قدر ضغط صغير بمقبض دفع مباشر</div>
                  <div class="Product-priceDetails"><span class="Product-minPrice">{{ currency }}{{
                      46.5, exchangerate | currency2
                    }}-{{ currency }}{{ 48.5, exchangerate | currency2 }}</span></div>
                </a>
              </div>
            </div>
          </div>
          <div class="recommended_item" v-on:click='goDetail(210)'>
            <div class="recommended_item_box">
              <a class="Product-media" href="javascript:void(0);">
                <img src="https://www.oubv.net/uploads/home/store/goods/13/20230711/13_2023071109262883154_240.png"
                     class="Product-image">
              </a>
              <div class="Product-details">
                <a class="Product-link" href="javascript:void(0);">
                  <div class="Product-name">25 قطعة حامل سكين التطهير بالأشعة فوق البنفسجية</div>
                  <div class="Product-priceDetails"><span
                    class="Product-minPrice">{{ currency }}{{ 48.5, exchangerate | currency2 }}</span></div>
                </a>
              </div>
            </div>
          </div>
          <div class="recommended_item" v-on:click='goDetail(209)'>
            <div class="recommended_item_box">
              <a class="Product-media" href="javascript:void(0);">
                <img src="https://www.oubv.net/uploads/home/store/goods/13/20230711/13_2023071109233032784_240.png"
                     class="Product-image">
              </a>
              <div class="Product-details">
                <a class="Product-link" href="javascript:void(0);">
                  <div class="Product-name">دلو أدوات المائدة 24 قطعة</div>
                  <div class="Product-priceDetails"><span
                    class="Product-minPrice">{{ currency }}{{ 19.5, exchangerate | currency2 }}</span></div>
                </a>
              </div>
            </div>
          </div>
          <div class="recommended_item" v-on:click='goDetail(207)'>
            <div class="recommended_item_box">
              <a class="Product-media" href="javascript:void(0);">
                <img src="https://www.oubv.net/uploads/home/store/goods/13/20230710/13_2023071013415184411_240.png"
                     class="Product-image">
              </a>
              <div class="Product-details">
                <a class="Product-link" href="javascript:void(0);">
                  <div class="Product-name">قدر ضغط صغير</div>
                  <div class="Product-priceDetails"><span class="Product-minPrice">{{ currency }}{{
                      46.5, exchangerate | currency2
                    }}-{{ currency }}{{ 48.5, exchangerate | currency2 }}</span></div>
                </a>
              </div>
            </div>
          </div>
          <div class="recommended_item" v-on:click='goDetail(213)'>
            <div class="recommended_item_box">
              <a class="Product-media" href="javascript:void(0);">
                <img src="https://www.oubv.net/uploads/home/store/goods/13/20230713/13_2023071317162266868_240.png"
                     class="Product-image">
              </a>
              <div class="Product-details">
                <a class="Product-link" href="javascript:void(0);">
                  <div class="Product-name">قاعدة الحديد لوحة التقطيع قاعدة السكين</div>
                  <div class="Product-priceDetails"><span
                    class="Product-minPrice">{{ currency }}{{ 15.8, exchangerate | currency2 }}</span></div>
                </a>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!--关于我们-->
      <div class="aboutus">
        <div class="aboutus_bt">
          <div class="h3">معلومات عنا</div>
        </div>
        <div class="aboutus_con">
          <div class="aboutus_con_video">
            <video src="https://www.oubv.net/static/home/images/editable_video1.mp4" muted="muted" loop="loop"
                   controls/>
          </div>
        </div>
      </div>

      <!--荣誉证书-->
      <div class="scenetext">
        <div class="scenetext_bt">
          <div class="h3">شهادة شرف</div>
        </div>
        <div class="scenetext_con">
          <div class="scenetext_item">
            <img src="//s.alicdn.com/@sc04/kf/Hf7d58d325c21454a8d43b1b07cee9be7S.jpg_300x300q80.jpg">
            <span>CE</span>
          </div>
          <div class="scenetext_item">
            <img src="//s.alicdn.com/@sc04/kf/H3c0e966fc9c44220849d929d252c7526l.jpg_300x300q80.jpg">
            <span>TUV mark</span>
          </div>
          <div class="scenetext_item">
            <img src="//s.alicdn.com/@sc04/kf/H9fec13d1826e445f9a4d633901f3609fY.jpg_300x300q80.jpg">
            <span>CE</span>
          </div>
          <div class="scenetext_item">
            <img src="//s.alicdn.com/@sc04/kf/Hee753942ac26407f9a14fa292494ec55N.jpg_300x300q80.jpg">
            <span>TUV mark</span>
          </div>
          <div class="scenetext_item">
            <img src="//s.alicdn.com/@sc04/kf/Hf39e5c0ce2674b4b8495a10e47def53c5.jpg_300x300q80.jpg">
            <span>Dekra</span>
          </div>
          <div class="scenetext_item">
            <img src="//s.alicdn.com/@sc04/kf/Hf6cde37324b94b4394c97c2c76f06bd6u.jpg_300x300q80.jpg">
            <span>CE</span>
          </div>
          <div class="scenetext_item">
            <img src="//s.alicdn.com/@sc04/kf/Hf843712bbbf3417fa04ee342dfbceddeO.jpg_300x300q80.jpg">
            <span>CE</span>
          </div>
          <div class="scenetext_item">
            <img src="//s.alicdn.com/@sc04/kf/H6c1e7ea76d7e4eebb22b0d72e993a71cm.jpg_300x300q80.jpg">
            <span>TUV mark</span>
          </div>
          <div class="scenetext_item">
            <img src="//s.alicdn.com/@sc04/kf/H3b9ee6ba70754df692f354b6400808122.jpg_300x300q80.jpg">
            <span>CE</span>
          </div>
        </div>

      </div>

      <common-store-footer :store_id="store.store_id"></common-store-footer>
      <mt-popup v-model="imageVisible" popup-transition="popup-fade" class="middle-popup">
        <img v-if="store.business_licence_number_electronic" :src="store.business_licence_number_electronic">
        <img v-if="store.is_platform_store && config.business_licence" :src="config.business_licence">
      </mt-popup>

    </div>
  </div>

</template>

<script>
import {mapState, mapActions} from 'vuex'
import {Toast} from 'mint-ui'
import StoreSpecialIndex from '../storespecial/Index'
import CommonStoreFooter from '../common/CommonStoreFooter'
import {getStoreInfo} from '@/api/homestoredetail'
import {getChatCount} from '@/api/memberInstantMessage'
import {addFavoriteStore, delFavoriteStore} from '@/api/memberFavorite'
import StoreSeckillList from './StoreSeckillList'
import StoreProductList from './StoreProductList'
import HeaderMore from '../../HeaderMore'

export default {
  name: 'Storedetail',
  data() {
    return {
      imageVisible: false,
      store: {
        store_id: this.$route.query.id ? this.$route.query.id : ''
      },
      rec_goods_list: false,
      popupVisible: false, // 弹出更多
      showDot: false,
      items: [
        {
          adv_code: 'https://www.oubv.net/static/home/images/store_banner1.jpg'
        },
        {
          adv_code: 'https://www.oubv.net/static/home/images/store_banner2.jpg'
        }
      ],
      floorAds: [
        'https://www.oubv.net/static/home/images/store_ad1.jpg',
        'https://www.oubv.net/static/home/images/store_ad1.jpg',
        'https://www.oubv.net/static/home/images/store_ad1.jpg',
        'https://www.oubv.net/static/home/images/store_ad1.jpg'
      ],
      seckill_goods_list: false
    }
  },
  components: {
    HeaderMore,
    StoreSeckillList,
    StoreProductList,
    CommonStoreFooter,
    StoreSpecialIndex
  },
  computed: {
    ...mapState({
      special: state => state.home.special,
      config: state => state.config.config,
      token: state => state.member.token,
      isOnline: state => state.member.isOnline,
      currency: state => state.currency.currency,
      exchangerate: state => state.currency.exchangerate
    }),
    getBannerStyle: function () {
      const {width} = window.screen
      let itemWidth = width
      let itemHeight = width * (94.0 / 188.0)
      return {
        width: itemWidth + 'px',
        height: itemHeight + 'px'
      }
    },
    isShowIndicators() {
      if (this.store.mb_sliders && this.store.mb_sliders.length > 1) {
        return true
      }
      return false
    },
    favoriteIco() {
      return this.store.is_favorate ? '&#xe64d;' : '&#xe64e;'
    },
    favoriteName() {
      return this.store.is_favorate ? 'جمعت' : 'المفضلة'
    },
    getBannerStyle2: function () {
      const {width} = window.screen
      let itemWidth = width
      let itemHeight = width * (94.0 / 188.0)
      return {
        width: itemWidth + 'px',
        height: itemHeight + 'px'
      }
    },
    isShowIndicators2() {
      if (this.items && this.items.length > 1) {
        return true
      }
      return false
    }
  },
  created() {
    getStoreInfo(
      this.store.store_id, this.token, this.currency
    ).then((res) => {
      this.store = res.result.store_info

      // 修改当前页面标题
      document.title = this.store.store_name

      this.seckill_goods_list = res.result.seckill_goods_list
      this.rec_goods_list = res.result.rec_goods_list
      if (this.store.is_platform_store) {
        this.fetchConfig({}).then(
          response => {
          },
          error => {
            Toast(error.message)
          }
        )
      }
      // eslint-disable-next-line handle-callback-err
    }).catch(function (error) {
    })
    if (this.isOnline) {
      getChatCount().then(res => {
        if (res.result) {
          if (!this.showDot) {
            this.showDot = {}
          }
          this.showDot['chat'] = true
        }
      })
    }
  },
  filters: {
    currency2(value, exchangerate) {
      let new_value = parseFloat(value * exchangerate).toFixed(2)
      return new_value
    }
  },
  methods: {
    ...mapActions({
      fetchConfig: 'fetchConfig'
    }),
    goLive(liveApplyId) {
      this.$router.push({'name': 'MemberLiveDetail', 'query': {'live_apply_id': liveApplyId}})
    },
    goAd(item) {
      if (item.type === 2) {
        this.$router.push({name: 'HomeGoodsdetail', query: {goods_id: item.link}})
      } else {
        window.location.href = item.link
      }
    },
    goStoreabout: function () {
      this.$router.push({name: 'HomeStoreabout', query: {id: this.$route.query.id}})
    },
    goDetail(item) {
      this.$router.push({'name': 'HomeGoodsdetail', 'query': {'goods_id': item}})
    },
    // 弹出更多
    popupMore() {
      if (!this.popupVisible) {
        this.popupVisible = true
      } else {
        this.popupVisible = false
      }
    },
    toggleFavorite() {
      if (!this.store.is_favorate) {
        addFavoriteStore(this.store.store_id).then(
          response => {
            Toast(response.message)
            this.store.is_favorate = !this.store.is_favorate
          },
          error => {
            Toast(error.message)
          }
        )
      } else {
        delFavoriteStore(this.store.store_id).then(
          response => {
            Toast(response.message)
            this.store.is_favorate = !this.store.is_favorate
          },
          error => {
            Toast(error.message)
          }
        )
      }
    }

  }

}
</script>

<style scoped>
.dot {
  position: absolute;
  width: .5rem;
  height: .5rem;
  background: red;
  border-radius: 50%;
  top: .2rem;
  right: 0;
}

.header {
  background: rgba(7, 17, 27, .5);
  color: #fff;
  overflow: hidden;
  position: relative;
  background-position: center;
  background-size: auto 100%;
}

.header .content-wrapper {
  -ms-flex-align: center;
  -webkit-box-align: center;
  align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding: 0.8rem 0.4rem;
  position: relative;
}

.header .content-wrapper .avatar {
  -ms-flex: 0 0 3rem;
  -webkit-box-flex: 0;
  flex: 0 0 3rem;
  margin-right: 0.4rem;
  width: 3rem;
}

.header .content-wrapper .avatar img {
  border-radius: 0.1rem;
  width: 3rem;
  height: 3rem;
}

.header .content-wrapper .content {
  position: relative;
  width: 8rem;
}

.header .content-wrapper .content .store_name {
  font-size: .8rem;
  font-weight: 700;
  margin-bottom: .4rem;
}

.header .content-wrapper .content .store_address span {
  font-size: .7rem
}

.follow_panel {
  position: absolute;
  top: 1rem;
  right: 2rem;
}

.follow_panel .follow_button {
  display: block;
  background: #e93b3d;
  border-radius: 2.5rem;
  padding: 0 0.4rem;
  line-height: 1.2rem;
  font-size: 0.6rem;
  color: #fff;
}

.follow_panel .follow_button i {
  line-height: 1.2rem;
}

.follow_panel .follow_number {
  text-align: center;
  line-height: 0.7rem;
  font-size: 0.5rem;
  color: #fff;
  margin-top: 0.5em;
}

.header-more {
  width: 2rem;
  height: 2rem;
  line-height: 2rem;
  position: absolute;
  top: 0.5rem;
  right: 0;
  color: #fff;
  text-align: center;
  font-size: 1rem;
}

.header .background {
  background: #2c3b53;
  -webkit-filter: blur(0.5rem);
  filter: blur(0.5rem);
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: -1;
}

.middle-popup {
  width: 80%
}

.middle-popup img {
  max-width: 100%
}

.box-wrapper {
  box-sizing: border-box;
  display: flex;
  align-content: flex-start;
  flex-shrink: 0;
}

.box-wrapper.v {
  -webkit-box-orient: vertical;
  flex-direction: column;
}

.box-wrapper.h {
  -webkit-box-orient: horizontal;
  flex-direction: row;
}

.box-wrapper .goods-price {
  text-align: center;
  font-size: 0;
  display: block;
  font-weight: 500;
  color: rgb(255, 255, 255);
  position: absolute;
  place-content: flex-start center;
  left: 0px;
  bottom: 0px;
  width: 2.61rem;
  height: .75rem;
  -webkit-box-pack: center;
  -webkit-box-align: center;
  align-items: center;
  border-bottom-left-radius: .15rem;
  border-bottom-right-radius: .15rem;
  background-color: rgba(0, 0, 0, 0.36);
}

.box-wrapper .goods-image {
  display: flex;
  width: 2.61rem;
  height: 2.61rem;
  border-radius: .15rem;
}

.box-wrapper .goods-wrapper {
  position: relative;
  -webkit-box-align: center;
  align-items: center;
  width: 2.61rem;
  height: 2.61rem;
  margin-left: .3rem;
}

.box-wrapper .currency {
  font-size: .6rem;
}

.box-wrapper .price {
  font-size: .65rem;
}

.box-wrapper .goods-list {
  position: relative;
  -webkit-box-align: center;
  align-items: center;
  margin-left: -.3rem;
  margin-top: .75rem;
}

.box-wrapper .live-title {
  position: relative;
  display: block;
  font-size: .8rem;
  width: 6.27rem;
  line-height: .75rem;
  font-weight: 500;
  color: rgb(255, 255, 255);
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.box-wrapper .live-desc {
  position: relative;
  height: .75rem;
  margin-top: .5rem;
}

.box-wrapper .live-count {
  position: absolute;
  display: block;
  font-size: .65rem;
  left: 0px;
  top: 0px;
  height: .75rem;
  margin-left: 2.76rem;
  line-height: .75rem;
  color: rgb(255, 255, 255);
}

.box-wrapper .live-icon {
  display: flex;
  width: 2.46rem;
  height: .75rem;
}

.box-wrapper .live-btn {
  position: absolute;
  place-content: flex-start center;
  top: 0px;
  right: 0px;
  -webkit-box-pack: center;
  -webkit-box-align: center;
  align-items: center;
  width: 3.56rem;
  height: 1.35rem;
  border-radius: .68rem;
  background-color: rgb(255, 255, 255);
}

.box-wrapper .live-btn-text {
  position: relative;
  display: block;
  font-size: .65rem;
  color: rgb(255, 52, 103);
}

.box-wrapper .left {
  position: relative;
  width: 5.6rem;
  height: 5.6rem;
}

.box-wrapper .right {
  position: relative;
  flex: 1 1 0%;
  -webkit-box-flex: 1;
  margin-left: .5rem;
}

.box-wrapper .live-info {
  position: relative;
  margin-top: .25rem;
}

.box-wrapper .live-store {
  position: absolute;
  display: block;
  font-size: .6rem;
  left: 0px;
  top: 0px;
  background-color: rgba(0, 0, 0, 0.36);
  border-top-left-radius: .3rem;
  border-bottom-right-radius: .75rem;
  padding: .075rem .5rem .075rem .35rem;
  color: rgb(255, 255, 255);
}

.box-wrapper .live-image {
  position: relative;
  height: 5.6rem;
  width: 5.6rem;
  border-radius: .3rem;
  overflow: hidden;
  background: #000
}

.box-wrapper .live-image img {
  width: 100%;
  height: 100%
}

.box-wrapper .live-image video {
  width: 100%;
  height: 100%
}

.box-wrapper .live-back-wrapper {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  overflow: hidden;
  height: 8rem;
}

.box-wrapper .live-back-image {
  display: flex;
  width: 100%;
  height: 8rem;
  transform: scale(4);
  object-fit: cover;
}

.box-wrapper .live-back-cover {
  position: absolute;
  left: 0px;
  top: 0px;
  right: 0px;
  bottom: 0px;
  background-color: rgba(0, 0, 0, 0.2);
}

.box-wrapper.live-wrapper {
  position: relative;
  width: 100%;
  height: 6.8rem;
  padding: .6rem;
  overflow: hidden;
}

.floor-ad {
  /*margin-top: 10px;*/
}

.floor-ad img {
  width: 100%;
  max-height: 5rem;
}

.new_arrivals {
  padding: 15px;
  padding: 0.6rem 15px;
  background: #eaeded;
}

.new_arrivals_bt {
}

.new_arrivals_bt .h3 {
  font-weight: 700;
  font-size: 16px;
  line-height: 1.25;
  color: #0F1111 !important;
}

.new_arrivals_con {
  margin-top: 8px;
  padding: 0;
  position: relative;
  font-size: 15px;
  margin-left: -15px;
  margin-right: -15px;
}

.new_arrivals_scroller {
  width: 100%;
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  overflow-y: hidden;
}

.new_arrivals_section {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  margin-right: 15px;
}

.new_arrivals_item {
  background-color: #fff;
  border-radius: 4px 4px 0 0;
  margin: 0 0 0 8px;
  padding: 8px 8px 12px;
  position: relative;
  width: 200px;
  box-sizing: border-box;
}

.new_arrivals_item:after {
  background: rgba(15, 17, 17, .03);
  content: "";
  height: 180px;
  left: 0;
  pointer-events: none;
  position: absolute;
  top: 0;
  width: 200px;
}

.new_arrivals_item .a-image-container {
  position: relative;
  height: 164px
}

.new_arrivals_item .a-image-container img {
  position: absolute;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  max-width: 100%;
  max-height: 100%;
}

.new_arrivals_item .a-spacing-top-base {
  margin-top: 1.2rem !important;
}

.new_arrivals_item .a-spacing-top-base .a-row {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 4px;
}

.new_arrivals_item .a-spacing-top-base .a-row > span {
  border-radius: 2px;
  font-weight: 400;
  line-height: 12px;
  padding: 4px 6px;
  position: relative;
  margin-left: 6px;
  margin-right: 0;
  /*background-color: #e93b3d;
  color: #ffffff;*/
  background-color: #ffffff;
  color: #e93b3d
}

.new_arrivals_item .a-desc {
  color: #0F1111;
}

.a-size-mini {
  font-size: 0.5rem;
  line-height: 1.5 !important;
}

.recommended {
  padding: 15px 15px 5px;
  background: #fff;
  margin-top: 0.6rem;
}

.recommended_bt {

}

.recommended_bt .h3 {
  font-weight: 700;
  font-size: 16px;
  line-height: 1.25;
  color: #0F1111 !important;
}

.recommended_con {
  margin-top: 15px;
  padding: 0;
  position: relative;
  color: #000;
  text-decoration: none;
  overflow: hidden;
  font-size: 12px;
  flex-basis: calc(50% - 5px);
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}

.recommended_item {
  flex-basis: 50%;
  padding-right: 5px;
  padding-left: 5px;
  margin-left: 0;
  margin-bottom: 10px;
  box-sizing: border-box;
}

.recommended_item_box {
  padding-bottom: 40px;
  position: relative;
  overflow: hidden;
  border: 1px solid #eaeded;
  border-radius: 4px;
}

.Product-media {
  box-sizing: border-box;
  display: block;
  position: relative;
  padding: 0 0 115%;
  background: #fafafa;
}

.Product-image {
  display: block;
  width: -webkit-calc(100% - 20px);;
  position: absolute;
  top: 10px;
  right: 10px;
}

.Product-details {
  box-sizing: border-box;
  width: 100%;
  min-height: 66px;
  background-color: hsla(0, 0%, 100%, .95);
  text-align: center;
  padding-top: 10px;
  position: absolute;
  right: 0;
  bottom: 0;
}

.Product-link {
  display: block;
}

.Product-name {
  color: #2d2d2d;
  font-size: 13px;
  margin-bottom: 5px;
}

.Product-name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: normal;
  width: 100%;
}

.Product-priceDetails {
  margin-bottom: 8px;
}

.Product-minPrice {
  white-space: nowrap;
  margin-bottom: 4px;
  line-height: normal;
  color: #e93b3d;
  margin-left: 5px;
  font-size: 13px;
}

.aboutus {
  padding: 0 15px 5px;
  margin-top: 0.6rem;
}

.aboutus_bt .h3 {
  font-weight: 700;
  font-size: 16px;
  line-height: 1.25;
  color: #0F1111 !important;
}

.aboutus_con {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-justify-content: flex-end;
  justify-content: flex-end;
  -webkit-align-items: center;
  align-items: center;
  margin-top: 0.6rem;
}

.aboutus_con_video video {
  background: #000;
  display: block;
  height: 100%;
  width: 100%;
}

.scenetext {
  padding: 0 15px 5px;
  margin-top: 0.6rem;
}

.scenetext_bt .h3 {
  font-weight: 700;
  font-size: 16px;
  line-height: 1.25;
  color: #0F1111 !important;
}

.scenetext_con {
  width: 100%;
  display: -webkit-flex;
  display: flex;
  margin-top: 0.6rem;
  overflow-x: scroll;
  overflow-y: hidden;
}
.scenetext_item{
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-flex-shrink: 0;
  flex-shrink: 0;
  white-space: nowrap;
  height: 37.333vw;
  text-align: center;
  position: relative;
  margin-left: 1.333vw;
  object-fit: contain;
  cursor: zoom-in;
}
.scenetext_item img{
  max-width: 32vw;
  height: 37.333vw;
  object-fit: contain;
  border-radius: 1.067vw;
}
.scenetext_item span{
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 9.333vw;
  line-height: 12.8vw;
  background: url(https://img.alicdn.com/imgextra/i1/O1CN01Qa2Gm81epPMKCnM34_!!6000000003920-2-tps-200-70.png) no-repeat 0 0;
  background-size: 100% 9.333vw;
  color: #fff;
  font-size: 14px;
}

</style>
